import React, { useState, useEffect } from "react";
import { T } from "../Translate";
import { Typography, AppBar, Toolbar, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { isLoggedIn } from "../../session";
import { useNavigate } from "react-router-dom";
import Atras from "../BackButton";

function CarsHeader() {
  const { carId } = useParams();
  const [carName, setCarName] = useState("");

  useEffect(() => {
    const fetchCarData = async () => {
      try {
        const db = getFirestore();
        const carDocRef = doc(db, "cars", carId);
        const carDocSnapshot = await getDoc(carDocRef);

        if (carDocSnapshot.exists()) {
          const carData = carDocSnapshot.data();
          const name = carData.title || <T>Vehiculo</T>;
          setCarName(name);
        } else {
          console.error("No se encontro el vehiculo.");
        }
      } catch (error) {
        console.error("Error fetching car data:", error);
      }
    };

    if (carId) {
      fetchCarData();
    }
  }, [carId]);

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);
  return (
    <AppBar position="fixed">
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            maxWidth: { xs: "100%", md: "980px" },
            mx: "auto",
            px: 2,
            boxSizing: "border-box",
          }}
        >
          <Atras color="inherit" />
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {carName || <T>Vehículo</T>}
            </Typography>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default CarsHeader;
